module.exports = __webpack_public_path__ + "img/cakto.174d0872.png";